module.exports = __webpack_public_path__ + "img/msg.da899a86.png";